module.exports = __webpack_public_path__ + "static/media/pauline.6cea8ba6.jpg";